import React, { useState } from 'react';
import Dialog from '../../../common/Dialog';
import Button from '../../../common/Button';
import { Box, Typography } from '@mui/material';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import TextEditor from '../../../common/TextEditor';

interface JobDescriptionPopupProps {
  open: boolean;
  onClose: () => void;
  onSave?: (jobDescription: string) => void;
  title?: string;
  subtitle?: string;
  initialJobDescription?: string;
  type?: 'add' | 'edit' | 'view';
}

const JobDescriptionPopup: React.FC<JobDescriptionPopupProps> = ({
  open,
  onClose,
  onSave,
  title = 'Senior Software Engineer',
  subtitle = 'Job Description',
  initialJobDescription = '',
  type = 'edit',
}) => {
  const [jobDescription, setJobDescription] = useState(initialJobDescription);

  return (
    <Dialog open={open} onClose={onClose}>
      <Box sx={{ p: 0, background: '#FAF8FF', borderRadius: '8px' }}>
        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: '32px 32px 0 32px' }}>
          <Box sx={{
            background: '#E5DEFF',
            borderRadius: '50%',
            width: 56,
            height: 56,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <WorkOutlineOutlinedIcon sx={{ color: '#6E3FF3', fontSize: 32 }} />
          </Box>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 700, color: '#23272E', lineHeight: 1.2 }}>
              {title}
            </Typography>
            <Typography variant="subtitle1" sx={{ color: '#A0A3BD', fontWeight: 600, fontSize: 20 }}>
              {subtitle}
            </Typography>
          </Box>
        </Box>
        {/* Content */}
        <Box sx={{ mx: '32px', mt: '24px' }}>
          <TextEditor
            value={jobDescription}
            editable={type !== 'view'}
            onChange={(value) => setJobDescription(value)}
          />
        </Box>
        {/* Actions */}
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, py: 4 }}>
          <Button variant="outlined" width="120px" onClick={onClose}>Close</Button>
          {type !== 'view' && (
            <Button variant="contained" width="120px" onClick={() => onSave?.(jobDescription)}>Save</Button>
          )}
        </Box>
      </Box>
    </Dialog>
  );
};

export default JobDescriptionPopup; 